import { render } from "./App.vue?vue&type=template&id=44cd3918"
const script = {}

import "./App.vue?vue&type=style&index=0&id=44cd3918&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__